type Props = {
    dataTestId?: string;
    symbol?: string;
};

const EmptyCell = ({ dataTestId, symbol = '-' }: Props) => {
    return <span data-testid={dataTestId}>{symbol}</span>;
};

export default EmptyCell;
